import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Button, TextField, FormControlLabel, Switch } from '@mui/material';
import toast from 'react-hot-toast';

export function InstallmentFormDialog({
  open,
  onClose,
  editingInst,
  formData,
  setFormData,
  handleSubmit,
  isCreating,
  isUpdating,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth disableRestoreFocus>
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ fontWeight: 600 }}>{editingInst ? 'Edit Installment' : 'Add Installment'}</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: 1 }}>
            <TextField
              label="Installment Name"
              required
              fullWidth
              size="small"
              placeholder="e.g. Month 1 Fee"
              value={formData.installment_name}
              onChange={(e) => setFormData({ ...formData, installment_name: e.target.value })}
            />

            <TextField
              label="Amount (₹)"
              type="number"
              required
              fullWidth
              size="small"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
            />

            <TextField
              label="Due Date"
              type="date"
              required
              fullWidth
              size="small"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              value={formData.due_date}
              onChange={(e) => setFormData({ ...formData, due_date: e.target.value })}
            />

            <TextField
              label="Grace Days (Max 30)"
              type="number"
              fullWidth
              size="small"
              slotProps={{ htmlInput: { min: 0, max: 30 } }}
              value={formData.grace_days}
              onChange={(e) => {
                let valNum = parseInt(e.target.value, 10);
                if (isNaN(valNum) || valNum < 0) valNum = 0;
                if (valNum > 30) {
                  toast.error('Grace period cannot exceed 30 days');
                  valNum = 30;
                }
                setFormData({ ...formData, grace_days: valNum });
              }}
            />

            <FormControlLabel
              control={
                <Switch
                  checked={formData.late_fee_applicable}
                  onChange={(e) => setFormData({ ...formData, late_fee_applicable: e.target.checked })}
                  color="warning"
                />
              }
              label="Late Fee Applicable"
            />

            <FormControlLabel
              control={
                <Switch
                  checked={formData.is_active}
                  onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                  color="success"
                />
              }
              label="Is Active"
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} disabled={isCreating || isUpdating}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" disabled={isCreating || isUpdating}>
            {isCreating || isUpdating ? 'Saving...' : editingInst ? 'Save Changes' : 'Add Installment'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
